<template>
  <div>
    <guide-menu></guide-menu>
    <notification-menu></notification-menu>
    <profile-menu :class-name="active"></profile-menu>
    <router-view/>
  </div>
</template>
<script>
import GuideMenu from '../components/GuideMenu/index';
import ProfileMenu from '../components/ProfileMenu/index';
import NotificationMenu from '../components/NotificationMenu/index';
import SocketService from '../services/SocketService';
import {getCookie} from '../utils/helperFunction';

export default {
  components: {
    GuideMenu,
    ProfileMenu,
    NotificationMenu
  },
  data() {
    return {
      searchText: null,
      searchTimerId: 0,
      searchResultList: [],
      searchResultShow: false,
      inputOpen: false,
      dashboardTypeList: ['board', 'list'],
      dashboardTypeSelected: 'board',
      currentState: false,
      toggled: false
    };
  },
  watch: {
    searchText(val) {
      clearTimeout(this.searchTimerId);
      if (val && val.trim()) {
        this.searchTimerId = setTimeout(() => {
          this.$api
              .get('tasks', {
                params: {
                  allSearch: val,
                  page: 0,
                  perPage: 10
                }
              })
              .then((response) => {
                this.searchResultList = response.data.data;
                this.searchResultShow = true;
              });
        }, 500);
      } else {
        this.searchResultShow = false;
      }
    }
  },
  created() {
    this.socketConnect();
  },
  mounted() {
    const lang = getCookie('lang') || 'uz';
    this.ChangeLang(lang);
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.az_all_search')) {
        this.inputOpen = false;
        this.searchResultShow = false;
      }
    });
  },
  beforeDestroy() {
    SocketService.Disconnect();
  },
  methods: {
    socketConnect() {
      SocketService.Connect(
          this.$store.state.socketURL,
          this.$store.state.userProfile
      );
    },
    getUserTasks() {
      this.myTask = !this.myTask;
      if (!this.myTask) {
        localStorage.removeItem('myTasks');
        this.$store.commit('setMembersProject', []);
      } else {
        localStorage.setItem('myTasks', this.$store.state.userProfile.id);
        this.$store.commit('setMembersProject', [this.$store.state.userProfile.id]);
      }
    },
    ChangeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);

      this.$api.post('/users/change/language', {
        langCode: lang
      });
    },
    GoToTask(item) {
      if (this.$route.name === 'dashboard') {
        this.$store.state.taskModalId = item.id;
      }

      this.$router
          .push({
            name: 'dashboard',
            params: {
              id: item.projectId,
              taskId: item.id
            }
          })
          .catch((err) => {
            console.log(err.name);
          });

      this.inputOpen = false;
      this.searchResultShow = false;
    }
  },
  computed: {
    active() {
      return this.$store.state.profileActiveClass;
    },
    projectData() {
      return this.$store.state.projectData;
    },
    isActive() {
      return this.currentState;
    },
    checkedValue: {
      get() {
        return this.defaultState;
      },
      set(newValue) {
        this.currentState = newValue;
      }
    }
  }
};
</script>
<style scoped>
.az_profile_lang_ls > li a {
  color: #3f4d67;
}

.language-btn {
  width: 35px;
  height: 35px;
  margin-top: 8px;
}
</style>
